module.exports = __webpack_public_path__ + "img/Z60_11.49c39318.jpg";